import { useState } from "react";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { searchMember } from "apiHandler/actions";
import searchIcon from "assets/search.png";
import {
  displayDateFormatter,
  DataGridCustomPagination,
} from "components/helpers";
import { useUserData } from "components/customHooks/userDataContext";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const columns = [
  {
    field: "fName",
    headerName: "First Name",
    flex: 1,
    renderCell: (e) => {
      return !e.row.registeredUser ? (
        <span>{e.value}</span>
      ) : (
        <Link
          to="/patientProfile"
          state={{ uuid: e.row.id }}
          className="member-search-name"
        >
          {e.value}
        </Link>
      );
    },
  },
  { field: "lName", headerName: "Last Name", flex: 1 },
  { field: "dob", headerName: "Date Of Birth", flex: 1 },
  { field: "age", headerName: "Age", flex: 1 },
  { field: "gender", headerName: "Gender", flex: 1 },
  { field: "contactNum", headerName: "Contact", flex: 1 },
];

const MemberSearch = (props) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState(null);
  const [rows, setRows] = useState([]);
  const userData = useUserData();
  const token = userData?.access_token;

  const searchHandler = async (e) => {
    e.preventDefault();
    // const { uuid, current_practice_location_id } = isAuthenticated();
    const payload = {
      //   practiceLocID: current_practice_location_id,
      //   practiceUserUUID: uuid,
      searchCriteria: {
        dob: dob,
        fname: firstName,
        lname: lastName,
      },
      pageIndex: 1,
    };
    let response = await searchMember(payload, token);
    let members = response?.responseBody?.members || [];
    setRows(
      members.map((m) => {
        return { ...m, id: m.uuid, dob: displayDateFormatter(m.dob) };
      })
    );
  };

  return (
    <div className="provider-member-search">
      <form>
        <div className="input-container">
          <img src={searchIcon} height={24} width={24} alt="" />
          <input
            placeholder="First Name"
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="input-container">
          <img src={searchIcon} height={24} width={24} alt="" />
          <input
            placeholder="Last Name"
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
        <DesktopDatePicker
          placeholder="MM/DD/YYYY"
          format="MM/DD/YYYY"
          value={dayjs(dob)}
          onChange={(e) => setDob(e)}
          slotProps={{ textField: { variant: "standard" } }}
        />
        <button className="submit" onClick={searchHandler}>
          Search
        </button>
      </form>
      <p className="disclaimer">
        Search members by First Name, Last Name or Date of Birth (MM/DD/YY)
      </p>
      <DataGrid
        rows={rows}
        columns={columns}
        autoHeight="true"
        disableRowSelectionOnClick
        pagination
        pageSize={10}
        slots={{
          pagination: DataGridCustomPagination,
        }}
      />
    </div>
  );
};

export default MemberSearch;
